jQuery(document).ready(function ($) {
  // Images
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\.[^/.]+$/, '');
    if (img.parent('a').length !== 0) {
      console.log('parent is a link');
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
  });

  $('.content-form .form-field input').each(function (e) {
    if ($(this).val().length > 0) {
      $(this).parent().addClass('has-content');
    } else {
      $(this).parent().removeClass('has-content');
    }
  });

  $('.content-form .form-field select').each(function (e) {
    if ($(this).val().length > 0) {
      $(this).parent().addClass('has-content');
    } else {
      $(this).parent().removeClass('has-content');
    }
  });

  // Tables
  $('main').responsiveTables();
  //Videos
  $('body').responsivevideos();

  if ($('ul.breadcrumb > li').length > 1) {
    $('.breadcrumbs').addClass('collapsed');
  }

  $('.collapsed ul.breadcrumb').on('click', function () {
    $('.breadcrumbs').toggleClass('expanded');
    $('.breadcrumbs').toggleClass('collapsed');
  });

  //Forms
  $('.content-form .form-field input').on('keydown', function (e) {
    if ($(this).val().length > 0) {
      $(this).parent().addClass('has-content');
    } else {
      $(this).parent().removeClass('has-content');
    }
  });

  $('.content-form .form-field textarea').on('keydown', function (e) {
    if ($(this).val().length > 0) {
      $(this).parent().addClass('has-content');
    } else {
      $(this).parent().removeClass('has-content');
    }
  });

  $('.content-form .form-field select').on('change', function (e) {
    if ($(this).val().length > 0) {
      $(this).parent().addClass('has-content');
    } else {
      $(this).parent().removeClass('has-content');
    }
  });

  $('.loc-show-all .btn').on('click', function () {
    $('.providers').toggleClass('show-all');
  });

  $('.mobile-filter-dropdown').on('click', function () {
    $('body').toggleClass('filter-menu-open');
  });

  if ($('.owl-carousel').length > 0) {
    $('.owl-carousel').each(function () {
      $(this).owlCarousel({
        loop: false,
        dots: true,
        responsive: {
          0: {
            items: 1
          },
          640: {
            items: 2
          },
          1024: {
            items: 3
          }
        }
      });
    });
  }

  if ($('.tab-nav').length > 0) {
    var $tabNav = $('.tab-nav');
    var $prevTab = $('.tab-nav .prev-tab');
    var $nextTab = $('.tab-nav .next-tab');
    var $tabControl = $tabNav.prev();
    var $currentTab = $tabControl.find('.tab-con a[aria-selected="true"]');
    var currentTabIndex = getTabIndexFromString($currentTab.attr('aria-controls'));
    var tabCount = $tabControl.find('.tab-con a').length;
    var nextTab, prevTab;

    //Initialize Tabs
    if (currentTabIndex < tabCount) {
      $nextTab.addClass('has-next');
      nextTabIndex = currentTabIndex + 1;
      nextTab = "tabs0tab" + nextTabIndex;
    } else {
      $nextTab.removeClass('has-next');
    }

    if (currentTabIndex > 1) {
      $prevTab.addClass('has-prev');
      prevTabIndex = currentTabIndex - 1;
      prevTab = "tabs0tab" + prevTabIndex;
    } else {
      $prevTab.removeClass('has-prev');
    }

    //Next Tab Click
    $('.next-tab').on('click', function () {
      if ($(this).hasClass('has-next')) {
        //Set Active
        $('a[aria-controls="' + nextTab + '"]').click();

        //Update Tab Tracking
        $currentTab = $tabControl.find('.tab-con a[aria-selected="true"]');
        currentTabIndex = getTabIndexFromString($currentTab.attr('aria-controls'));

        if (currentTabIndex < tabCount) {
          $nextTab.addClass('has-next');
          nextTabIndex = currentTabIndex + 1;
          nextTab = "tabs0tab" + nextTabIndex;
        } else {
          $nextTab.removeClass('has-next');
        }

        if (currentTabIndex > 1) {
          $prevTab.addClass('has-prev');
          prevTabIndex = currentTabIndex - 1;
          prevTab = "tabs0tab" + prevTabIndex;
        } else {
          $prevTab.removeClass('has-prev');
        }
      }
    });

    //Previous Tab Click
    $('.prev-tab').on('click', function () {
      if ($(this).hasClass('has-prev')) {
        //Set Active
        $('a[aria-controls="' + prevTab + '"]').click();

        //Update Tab Tracking
        $currentTab = $tabControl.find('.tab-con a[aria-selected="true"]');
        currentTabIndex = getTabIndexFromString($currentTab.attr('aria-controls'));

        if (currentTabIndex < tabCount) {
          $nextTab.addClass('has-next');
          nextTabIndex = currentTabIndex + 1;
          nextTab = "tabs0tab" + nextTabIndex;
        } else {
          $nextTab.removeClass('has-next');
        }

        if (currentTabIndex > 1) {
          $prevTab.addClass('has-prev');
          prevTabIndex = currentTabIndex - 1;
          prevTab = "tabs0tab" + prevTabIndex;
        } else {
          $prevTab.removeClass('has-prev');
        }
      }
    });
  }

    //provider directory scroll to top
    $(window).scroll(function () {
        if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
            $('#return-to-top').fadeIn(200);    // Fade in the arrow
        } else {
            $('#return-to-top').fadeOut(200);   // Else fade out the arrow
        }
    });
    $('#return-to-top').click(function () {      // When arrow is clicked
        $('body,html').animate({
            scrollTop: 0                       // Scroll to top of body
        }, 500);
    });

});

function getTabIndexFromString(controlString) {
  return parseInt(controlString.substr(controlString.lastIndexOf('tab') + 3, controlString.length));
}